import React, { useState, useRef, useEffect } from 'react';
import Select, { components } from 'react-select';
import ReactDOM from 'react-dom';

const modalState = {
    colorModalOpen: false,
    selectModalOpen: false,
    listeners: new Set(),
    notifyListeners() {
        this.listeners.forEach((listener) => listener());
    },
    addListener(listener) {
        this.listeners.add(listener);
    },
    removeListener(listener) {
        this.listeners.delete(listener);
    },
};

const globalClickOutsideHandler = (event) => {
    const isClickInColorModal = event.target.closest('.tag-modal');
    const isClickInSelectMenu = event.target.closest('[class*="menu"]');
    const isClickInSelectControl = event.target.closest('[class*="control"]');
    const isClickInSelectOption = event.target.closest('[class*="option"]');

    if (modalState.colorModalOpen && !isClickInColorModal) {
        modalState.colorModalOpen = false;
        modalState.notifyListeners();

        const activeModal = document.querySelector('.tag-modal');
        if (activeModal && activeModal._closeModal) {
            activeModal._closeModal();
        }
        return;
    }

    if (
        modalState.selectModalOpen &&
        !isClickInColorModal &&
        !isClickInSelectMenu &&
        !isClickInSelectControl &&
        !isClickInSelectOption
    ) {
        modalState.selectModalOpen = false;
        modalState.notifyListeners();
        return;
    }
};

if (typeof document !== 'undefined') {
    document.addEventListener('mousedown', globalClickOutsideHandler);
}
const statusColors = [
    '#3b82f6',
    '#60a5fa',
    '#38bdf8',
    '#22d3ee',
    '#14b8a6',
    '#22c55e',
    '#a3e635',
    '#eab308',
    '#facc15',
    '#f59e0b',
    '#f97316',
    '#ef4444',
    '#ec4899',
    '#8b5cf6',
    '#a855f7',
    '#d1d5db',
    '#6b7280',
    '#374151',
    '#000000',
];

const getContrastColor = (hexColor = '#2196f3') => {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000' : '#fff';
};

const customStyles = {
    control: (base) => ({
        ...base,
        minHeight: '36px',
        border: '1px solid #e2e8f0',
        borderRadius: '6px',
        boxShadow: 'none',
        backgroundColor: '#ffffff',
        '&:hover': {
            borderColor: '#cbd5e1',
        },
        '&:focus-within': {
            borderColor: '#3b82f6',
            boxShadow: '0 0 0 1px #3b82f6',
        },
    }),
    placeholder: (base) => ({
        ...base,
        color: '#94a3b8',
        fontSize: '14px',
    }),
    input: (base) => ({
        ...base,
        fontSize: '14px',
        color: '#1e293b',
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '4px 8px',
    }),
    multiValue: (base, { data }) => {
        const color = data.color || '#2196f3';
        return {
            ...base,
            backgroundColor: color,
            borderRadius: '4px',
            margin: '2px',
        };
    },
    multiValueLabel: (base, { data }) => ({
        ...base,
        color: getContrastColor(data.color || '#2196f3'),
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 6px',
    }),
    multiValueRemove: (base, { data }) => ({
        ...base,
        color: getContrastColor(data.color || '#2196f3'),
        ':hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            color: getContrastColor(data.color || '#2196f3'),
        },
    }),
    option: (base, { isFocused, isSelected, data }) => {
        const color = data.color || '#2196f3';
        return {
            ...base,
            backgroundColor: isFocused ? '#f1f5f9' : 'transparent',
            color: isSelected ? getContrastColor(color) : '#1e293b',
            cursor: 'pointer',
            padding: '8px 12px',
            fontSize: '14px',
            border: 'none',
            ':active': {
                backgroundColor: '#e2e8f0',
            },
        };
    },
    menu: (base) => ({
        ...base,

        margin: '0',


        backgroundColor: '#ffffff',
        zIndex: 9999,

    }),
    menuList: (base) => ({
        ...base,
        padding: '4px 0',
    }),
    indicatorsContainer: (base) => ({
        ...base,
        paddingRight: '8px',
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: '#64748b',
        ':hover': {
            color: '#475569',
        },
    }),
};

const MultiValue = (props) => {
    const tagcolor = props.data.className || '#2196F3';

    return (
        <div
            className="flex items-center  px-1 py-1 mr-1 mb-1 text-sm"
            style={{ borderColor: tagcolor, color: tagcolor, border: `1px solid ${tagcolor}`, borderRadius: '4px' }}
        >
            <span className="mr-1 fs-[13px] px-1 rounded ">{props.data.label}</span>

            <components.MultiValueRemove {...props}>
                <span
                    {...props.removeProps}
                    className="ml-1 cursor-pointer"
                    style={{ color: tagcolor }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.color = tagcolor;
                    }}
                >
                    ×
                </span>
            </components.MultiValueRemove>
        </div>
    );
};
const CustomOption = (props) => {
    const tagColor = props.data.color || '#2196f3';
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [isDeleting, setIsDeleting] = useState(false);
    const [editTagColor, setEditTagColor] = useState(tagColor);
    const setSelectedTagColor = props.selectProps?.setSelectedTagColor;
    const handleSelecteTag = props.selectProps?.handleSelecteTag;
    const handleUpdatedCustomField = props.selectProps?.handleUpdatedCustomField;
    const item = props.selectProps?.item;
    const setCustomeFieldId = props.selectProps?.setCustomeFieldId;
    const deleteCustomField = props.selectProps?.deleteCustomField;
    const editTagName = props.selectProps?.editTagName || props.data.label || '';
    const setEditTagName = props.selectProps?.setEditTagName || (() => { });
    const [hoveredId, setHoveredId] = useState(null);
    const [iseditTag, setEditTag] = useState(editTagName || props.data.label || '');

    useEffect(() => {
        const handleModalStateChange = () => {
            if (!modalState.colorModalOpen && isModalOpen) {
                setIsModalOpen(false);
            }
        };

        modalState.addListener(handleModalStateChange);
        return () => modalState.removeListener(handleModalStateChange);
    }, []);

    const handleSliderClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const rect = e.currentTarget.getBoundingClientRect();
        const modalWidth = 280;
        const modalHeight = 220;

        let top = rect.top + window.scrollY - modalHeight;
        let left = rect.left + window.scrollX;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        if (top < 20) {
            top = rect.top + window.scrollY;
        }

        if (top + modalHeight > viewportHeight + window.scrollY - 20) {
            top = Math.max(20, (viewportHeight - modalHeight) / 2);
        }

        if (left + modalWidth > viewportWidth - 30) {
            left = Math.max(20, viewportWidth - modalWidth - 20);
        }

        if (left < 30) {
            left = 20;
        }

        if (top < 30) {
            top = 30;
        }

        setPosition({ top, left });

        const currentLabel = props.data.label || '';
        const currentTagId = props.data.tagId || props.data.id || null;
        setEditTagName(currentLabel);
        setEditTag(currentLabel);
        setEditTagColor(tagColor);

        if (currentTagId) {
            setCustomeFieldId(currentTagId);
        }

        if (setSelectedTagColor) {
            setSelectedTagColor(tagColor);
        }

        setIsModalOpen(true);
        modalState.colorModalOpen = true;
        modalState.notifyListeners();
    };

    const closeModal = () => {
        setIsModalOpen(false);
        modalState.colorModalOpen = false;
        modalState.notifyListeners();

        if (isDeleting) {
            setIsDeleting(false);
            return;
        }

        if (handleSelecteTag || (editTagName && editTagName.trim()) || editTagColor) {
            const selectedIndex =
                props.selectProps?.options?.findIndex((option) => option.value === props.data.value) || 0;
            handleSelecteTag(item, editTagName.trim(), editTagColor, selectedIndex);
        }
    };

    React.useEffect(() => {
        if (isModalOpen) {
            const currentLabel = props.data.label || '';
            setEditTagName(currentLabel);
            setEditTag(currentLabel);
        }
    }, [isModalOpen]);

    useEffect(() => {
        if (!editTagColor && statusColors?.length > 0) {
            setEditTagColor(statusColors[0]);
            setSelectedTagColor?.(statusColors[0]);
        }
    }, [statusColors]);

    return (
        <components.Option {...props}>
            <div className="relative group w-full p-0 mt-0">
                <div className="flex items-center justify-between" onMouseEnter={() => setHoveredId(props.data.id)}
                    onMouseLeave={() => setHoveredId(null)}>
                    <div
                        className="flex items-center"

                        style={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            backgroundColor: 'transparent',
                            color: tagColor,
                            border: `1px solid ${tagColor}`,
                            fontSize: '12px',
                        }}
                    >
                        <span>#{props.data.label}</span>

                    </div>
                    <div>
                        <span> <i
                            className="bi bi-sliders ml-2 text-gray-500 hover:text-black text-sm cursor-pointer"
                            onClick={handleSliderClick}
                            style={{
                                fontSize: 14,
                                opacity: hoveredId === props.data.id ? 1 : 0,
                                pointerEvents: hoveredId === props.data.id ? 'auto' : 'none',
                                transition: 'opacity 150ms',
                            }}
                        /></span>
                        <span style={{ marginLeft: 6, cursor: 'grab', fontSize: 14, color: 'black' }}>
                            ⋮⋮
                        </span>
                    </div>
                </div>

                {isModalOpen &&
                    ReactDOM.createPortal(
                        <div
                            className="absolute w-72 p-4 bg-white border rounded-lg shadow-xl tag-modal"
                            style={{
                                position: 'fixed',
                                top: position.top,
                                left: position.left - 100,
                                zIndex: 10000,
                                minWidth: '250px',
                                maxWidth: '250px',
                                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                                border: '1px solid #e5e7eb',
                                backgroundColor: 'white',
                            }}
                            ref={(el) => {
                                if (el) {
                                    el._closeModal = closeModal;
                                }
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                            }}
                            onMouseDown={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                            }}
                        >
                            <div className="flex justify-between items-center mb-1 pb-1 border-b border-gray-200">
                                <span className="font-semibold text-sm text-black">Option details</span>
                                <div className="flex items-center gap-2">
                                    <i
                                        className="bi bi-trash text-gray-800 hover:text-black cursor-pointer text-sm"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            setIsDeleting(true);
                                            deleteCustomField(props.data.tagId, '', item);
                                            setIsModalOpen(false);
                                        }}
                                    />
                                </div>
                            </div>

                            <div
                                className="mb-1"
                                onClick={(e) => e.stopPropagation()}
                                onMouseDown={(e) => e.stopPropagation()}
                            >
                                <input
                                    type="text"
                                    placeholder="#tag"
                                    value={editTagName || ''}
                                    className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        setEditTagName(e.target.value);
                                        setEditTag(e.target.value);
                                    }}
                                    onKeyDown={(e) => {
                                        e.stopPropagation();
                                        if (e.key === 'Enter') {
                                            if (handleSelecteTag && item) {
                                                const selectedIndex =
                                                    props.selectProps?.options?.findIndex(
                                                        (option) => option.value === props.data.value,
                                                    ) || 0;
                                                handleSelecteTag(item, editTagName.trim(), editTagColor, selectedIndex);
                                            }
                                        }
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }}
                                    onFocus={(e) => {
                                        e.stopPropagation();
                                        e.target.select();
                                    }}
                                    autoFocus
                                />
                            </div>

                            <p className="text-sm font-medium mb-2 text-gray-800">Colors</p>
                            <div className="grid grid-cols-6 gap-2">
                                {statusColors.map((color, idx) => {
                                    const isSelected = editTagColor === color;

                                    return (
                                        <div
                                            key={idx}
                                            className="w-[24px] h-[24px] rounded-full cursor-pointer flex items-center justify-center transition-transform hover:scale-110 border-2"
                                            style={{
                                                borderColor: color,
                                                backgroundColor: 'white',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setEditTagColor(color);
                                                setSelectedTagColor?.(color);
                                            }}
                                        >
                                            {isSelected && (
                                                <span className="text-[13px] font-bold" style={{ color: color }}>
                                                    ✓
                                                </span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="flex justify-end gap-2">
                                <button
                                    className="text-xs text-white px-3 py-1.5 rounded-md hover:bg-blue-600 transition-colors"
                                    style={{ backgroundColor: 'rgb(22, 96, 200)' }}

                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleSelecteTag(
                                            props?.selectProps?.taskItem?.id,
                                            item?.id,
                                            editTagName,
                                            item,
                                            editTagColor,
                                        );
                                        setIsModalOpen(false)
                                        setHoveredId(null)
                                    }}
                                >
                                    Save
                                </button>
                                <button
                                    className="text-xs bg-gray-200 text-gray-700 px-3 py-1.5 rounded-md hover:bg-gray-300 transition-colors"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        closeModal();
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>,
                        document.body,
                    )}
            </div>
        </components.Option>
    );
};

const normalizeTag = (val, tagId = null) => {
    if (!val) return null;
    if (typeof val === 'object' && val.label) {
        let realId = val.tagId || val.id || tagId;
        if (realId && typeof realId !== 'string') {
            realId = String(realId);
        }
        return {
            label: val.label,
            value: val.value || val.label,
            color: val.color,
            tagId: realId,
            id: realId,
            flag: val.flag,
        };
    }
    return null;
};

const normalizeTagArray = (tagArray) => (tagArray || []).map((tag) => normalizeTag(tag)).filter(Boolean);

const generateFilteredOptions = (tagFieldsData, input = '') => {
    const rawTags =
        tagFieldsData?.flatMap((tag) => {
            const fallbackColor = tag.customField?.color || '#2196f3';
            let values = tag?.customField?.value ?? [];
            values = Array.isArray(values) ? values.flat(Infinity) : [values];
            return values
                .map((val) => {
                    const isHexColor = /^#[0-9A-Fa-f]{6}$/.test(val);
                    if (isHexColor) {
                        return {
                            label: `Color ${val}`,
                            value: val,
                            color: val,
                            tagId: tag?.id,
                            flag: val?.flag,
                        };
                    }
                    return normalizeTag(val, tag?.id);
                })
                .filter(Boolean);
        }) ?? [];

    const uniqueTags = rawTags.filter((tag, index, self) => index === self.findIndex((t) => t.label === tag.label));

    return uniqueTags.filter((tag) => (tag.label || '').toLowerCase().includes(input.toLowerCase()));
};

const TagSelectTable = ({
    openStatusIndex,
    tagFieldsData,
    handleStatusClick,
    item,
    handleSelecteTag,
    setSelectedFilterTagVal,
    selectedFilterTagVal,
    setSelectedTagColor,
    customeFiedId,
    setCustomeFieldId,
    deleteCustomField,
    editTagName,
    setEditTagName,
    taskItem,
    selectedTags,
    selectedFieldId,
    idx,


    handletaskUpdate,
    customprokey,
    setCustomprokey,
    triggerTaskUpdate,
    setTriggerTaskUpdate,
    updateCustomProKey,
    selecteTagItem,
    formattedTag,
    handleUpdatedCustomField,
    handleRemoveCustomField,
    setOpenStatusIndex,
}) => {
    const [inputValue, setInputValue] = useState('');
    const [menuIsOpen, setMenuIsOpen] = useState(true);
    const [currentSelectedColor, setCurrentSelectedColor] = useState('#2196f3');
    const isOpen = openStatusIndex === idx;

    const handleMenuOpen = () => {
        setOpenStatusIndex(idx);
    };

    const handleMenuClose = () => {
        setOpenStatusIndex(null);
    };
    useEffect(() => {
        const handleModalStateChange = () => {
            if (!modalState.selectModalOpen && menuIsOpen) {
                setMenuIsOpen(false);
            }
        };

        modalState.addListener(handleModalStateChange);
        return () => modalState.removeListener(handleModalStateChange);
    }, [menuIsOpen]);

    useEffect(() => {
        modalState.selectModalOpen = menuIsOpen;
        modalState.notifyListeners();
    }, [menuIsOpen]);



    const filteredTags = formattedTag;

    const normalizedSelectedValues = normalizeTagArray(filteredTags);
    const filteredOptions = generateFilteredOptions(tagFieldsData, inputValue);
    const masteroptionsData = generateFilteredOptions(tagFieldsData, '');

    const handleChange = async (newSelected, actionMeta) => {
        const normalized = normalizeTagArray(newSelected);
        const unique = normalized.filter((tag, index, self) => index === self.findIndex((t) => t.label === tag.label));

        const taskId = taskItem?.id;
        const propertyId = item?.id;
        if (!taskId || !propertyId) return;

        const prevTagObj = selectedTags?.[taskId]?.[propertyId] || { value: [] };
        const currentValues = Array.isArray(prevTagObj.value) ? [...prevTagObj.value] : [];

        if (actionMeta.action === 'select-option') {
            const lastSelected = actionMeta.option;
            const tagValId = lastSelected?.id;

            await updateCustomProKey(item, tagValId, newSelected, taskItem);

            const isAlreadySelected = unique.some((tag) => tag.label === lastSelected.label);

            if (isAlreadySelected && handleSelecteTag) {
                const tagColor = lastSelected?.color || '#2196f3';
                const selectedIndex = unique.findIndex((tag) => tag.label === lastSelected.label);

                if (setSelectedTagColor) {
                    setSelectedTagColor(tagColor);
                }
                setCurrentSelectedColor(tagColor);
            }
        }
        if (actionMeta.action === 'remove-value') {
            const lastSelected = actionMeta.option;
            const tagValId = lastSelected?.id;
            await updateCustomProKey(item, tagValId, newSelected, taskItem, 'remove');

        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && inputValue.trim()) {
            event.preventDefault();

            const isHexColor = /^#[0-9A-Fa-f]{6}$/.test(inputValue.trim());
            let tagLabel, tagColor;

            if (isHexColor) {
                tagLabel = `Color ${inputValue.trim()}`;
                tagColor = inputValue.trim();
            } else {
                tagLabel = inputValue.trim();
                tagColor = currentSelectedColor;
            }

            const newTag = normalizeTag({ label: tagLabel, value: tagLabel, color: tagColor }, tagColor);

            const updatedValues = [...normalizedSelectedValues, newTag];

            if (handleSelecteTag) {
                const selectedIndex = normalizedSelectedValues.length;

                handleSelecteTag(taskItem?.id, item?.id, inputValue, item);
            }

            setInputValue('');
        }
    };

    function filterObjectsByIds(idArray, objectArray) {
        return objectArray?.filter((obj) => idArray?.includes(obj.id));
    }

    const formattedTagNew = filterObjectsByIds(selectedFieldId, masteroptionsData);

    const formatted = formattedTagNew.map((item) => ({
        label: ` #${item.label}`,
        value: item.value,
        className: item.color || '',
        id: item?.id,
    }));

    return (
        <>
            <Select
                className="fs-[13px]"
                style={{ border: '0px ' }}
                key={idx}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                    MultiValue: MultiValue,
                    Option: CustomOption,
                }}
                inputValue={inputValue}
                styles={customStyles}
                value={formatted}
                onChange={handleChange}
                onInputChange={(value, { action }) => {
                    if (action === 'input-change') {
                        setInputValue(value);
                    }
                }}
                onKeyDown={handleKeyDown}
                options={filteredOptions}
                placeholder={`Type to create or select an option`}
                noOptionsMessage={() => 'No tags found'}
                isClearable={false}
                menuIsOpen={menuIsOpen}


                setSelectedTagColor={setSelectedTagColor}
                handleSelecteTag={handleSelecteTag}
                item={item}
                setCustomeFieldId={setCustomeFieldId}
                deleteCustomField={deleteCustomField}
                editTagName={editTagName}
                setEditTagName={setEditTagName}
                taskItem={taskItem}
                handleUpdatedCustomField={handleUpdatedCustomField}

            />
        </>
    );
};

export default TagSelectTable;
